import React, { Component } from 'react';

export default class OnePane extends Component {
  render() {
    return (
      <div className="container-fluid">
        <div className="row justify-content-md-center align-items-center" style={{ height: '100vh' }}>
          {this.props.children}
        </div>
      </div>
    );
  }
}
